import { RouterModule } from "@angular/router";
import { PipelineComponent } from "./components/pipeline/pipeline.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// DATATABLE
import { DatatableModule as innModule } from "inn-datatable";

import { DragDropModule } from "@angular/cdk/drag-drop";
import { SelectDropDownModule } from "ngx-select-dropdown";
import { ChartsModule } from "ng2-charts";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";

import { FeedsComponent } from "./components/feeds/feeds.component";
import { IntegrationComponent } from "./components/integration/integration.component";
import { ScoreComponent } from "./components/score/score.component";
import { ChartComponent } from "./components/chart/chart.component";
import { CalendarComponent } from "./components/calendar/calendar.component";
import { ViewDocComponent } from "./components/view-doc/view-doc.component";
import { LibraryUploadComponent } from "./components/library-upload/library-upload.component";
import { DealModalComponent } from "./components/deal-modal/deal-modal.component";
import { TextEditorComponent } from "./components/text-editor/text-editor.component";
import { LoadingSpinnerComponent } from "./components/loading-spinner/loading-spinner.component";
import { DatepickerMinModeComponent } from "./components/datepicker-min-mode/datepicker-min-mode.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { TaskFeedsComponent } from "./components/feeds/task-feeds/task-feeds.component";
import { NotesComponent } from "./components/integration/notes/notes.component";
import { NoteFeedsComponent } from "./components/feeds/note-feeds/note-feeds.component";
import { LogActivityComponent } from "./components/integration/log-activity/log-activity.component";
import { DatatableComponent } from "./components/datatable/datatable.component"; // custom datatable module
import { SalesOrderDatatableComponent } from "./components/salesorder-datatable/salesorder-datatable.component";
import { AddMoreUsersToLicenseComponent } from "./components/add-more-users-to-license/addMoreUsers.component"
import { TicketCallComponent } from "./components/ticket-call/ticket-call.component";

import { EmailComponent } from "./components/integration/email/email.component";
import { EmailFeedsComponent } from "./components/feeds/email-feeds/email-feeds.component";
import { EmailLookupComponent } from "./components/email-lookup/email-lookup.component";
import { ImapComponent } from "./components/imap/imap.component";

/** WYSIWYG EDITOR */
import { QuillModule } from "ngx-quill";
import { LogactivityFeedsComponent } from "./components/feeds/logactivity-feeds/logactivity-feeds.component";
import { AddCardModalComponent } from "./components/add-card-modal/add-card-modal.component";
import { DashStatsComponent } from "./components/dash-stats/dash-stats.component";
import { FilterPipe } from "../utils/filter.pipe";
import { DataFilterComponent } from "./components/data-filter/data-filter.component";
import { UniquePipe } from "../utils/unique.pipe";
import { SalesOrderTransitionModalComponent } from "./components/sales-order-transition-modal/sales-order-transition-modal";
import { ClientComponent } from "./components/integration/client-tasks/client-tasks.component";
import { NgxPaginationModule } from "ngx-pagination";
import { NgSelectModule } from "@ng-select/ng-select";
import { FlowTemplateComponent } from "./components/flow-template/flow-template.component";
import { TruncatePipe } from "../utils/truncate.pipe";
import { LaddaModule } from "angular2-ladda";
import { SharedService } from "./shared.service";
import { AddTeamsModalComponent } from "./components/add-teams-modal/add-teams-modal.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";

import { ClientsComponent } from "./components/suggestions/clients/clients.component";
import { SuggestionsComponent } from "./components/suggestions/suggestions.component";
import { TaskModalComponent } from "./components/task-modal/task-modal.component";
import { AddTerritoryModalComponent } from "./components/add-territory-modal/add-territory-modal.component";
import { NoteFeedsListComponent } from "./components/feeds/note-feeds/note-feeds-list/note-feeds-list.component";
import { LogFeedsListComponent } from "./components/feeds/logactivity-feeds/log-feeds-list/log-feeds-list.component";

//ng Mat
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { EmailFeedItemComponent } from "./components/feeds/email-feeds/email-feed-item/email-feed-item.component";
import { AllFeedsComponent } from "./components/feeds/all-feeds/all-feeds.component";
import { FacebookComponent } from "./components/integration/facebook/facebook.component";
import { FacebookPagesComponent } from "./components/facebook-pages/facebook-pages.component";
import { SocialFeedComponent } from "./components/social-feed/social-feed.component";
import { TwitterItemComponent } from "./components/social-feed/twitter-item/twitter-item.component";
import { FacebookItemComponent } from "./components/social-feed/facebook-item/facebook-item.component";
import { TwitterReplyComponent } from "./components/social-feed/twitter-reply/twitter-reply.component";
import { FacebookReplyComponent } from "./components/social-feed/facebook-reply/facebook-reply.component";
import { FacebookPostComponent } from "./components/social-feed/facebook-post/facebook-post.component";
import { MatCurrencyFormatModule } from "mat-currency-format";
import { SendInvoiceComponent } from "../sales/invoice/send-invoice/send-invoice.component";
import { DatatableSsrComponent } from './components/datatable-ssr/datatable-ssr.component';
import { CreateCompanyFormComponent } from "./create-forms/create-company-form/create-company-form.component";
import { CreateContactCompanyFormComponent } from "./create-forms/create-contact-company-form/create-contact-company-form.component";
import { CreateContactFormComponent } from "./create-forms/create-contact-form/create-contact-form.component";
import { HeaderMailComponent } from './components/integration/email/header-mail/header-mail.component';

const sharedComponent = [
  FeedsComponent,
  EmailLookupComponent,
  ImapComponent,
  IntegrationComponent,
  ScoreComponent,
  ChartComponent,
  ViewDocComponent,
  LibraryUploadComponent,
  PipelineComponent,
  DealModalComponent,
  SalesOrderTransitionModalComponent,
  LoadingSpinnerComponent,
  DatepickerMinModeComponent,
  DatatableComponent,
  SalesOrderDatatableComponent,
  AddMoreUsersToLicenseComponent,
  DashStatsComponent,
  DataFilterComponent,
  FlowTemplateComponent,
  TruncatePipe,
  AddTeamsModalComponent,
  ClientsComponent,
  SuggestionsComponent,
  AddTerritoryModalComponent,
  TicketCallComponent,
  FacebookComponent,
  FacebookPagesComponent,
  SocialFeedComponent,
  DatatableSsrComponent,
  CreateContactFormComponent,
  CreateCompanyFormComponent,
  CreateContactCompanyFormComponent, 
];

const sharedModules = [
  SelectDropDownModule,
  FormsModule,
  ReactiveFormsModule,
  NgSelectModule,
  DragDropModule,
  NgMultiSelectDropDownModule,
  innModule,
  MatProgressBarModule,
  ChartsModule,
  MatCurrencyFormatModule,
];

@NgModule({
  declarations: [
    ...sharedComponent,
    CalendarComponent,
    EmailComponent,
    SendInvoiceComponent,
    EmailFeedsComponent,
    EmailFeedItemComponent,
    LogActivityComponent,
    TextEditorComponent,
    TaskFeedsComponent,
    ClientComponent,
    NotesComponent,
    TaskModalComponent,
    NoteFeedsComponent,
    NoteFeedsListComponent,
    LogActivityComponent,
    LogactivityFeedsComponent,
    LogFeedsListComponent,
    AddCardModalComponent,
    FilterPipe,
    UniquePipe,
    FlowTemplateComponent,
    AllFeedsComponent,
    TwitterItemComponent,
    FacebookItemComponent,
    TwitterReplyComponent,
    FacebookReplyComponent,
    FacebookPostComponent,
    CreateContactFormComponent,
    CreateContactCompanyFormComponent,
    CreateCompanyFormComponent,
    HeaderMailComponent,
  ],

  imports: [
    ...sharedModules,
    CommonModule,
    RouterModule,
    NgxPaginationModule,
    QuillModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    LaddaModule,
    innModule,
  ],

  providers: [SharedService],

  exports: [
    ...sharedComponent,
    ...sharedModules,
    EmailComponent,
    HeaderMailComponent,
    SendInvoiceComponent,
    NotesComponent,
    TaskModalComponent,
    LogActivityComponent,
    FlowTemplateComponent,
  ],

  entryComponents: [AddCardModalComponent],
})
export class SharedModule {}
